import ConfigData from 'config/ConfigData';
import getAppSite from 'utils/getAppSite';

export const sourceOptions = [
  {
    name: 'Latest news',
    type: 'KeyUpdate',
  },
  {
    name: 'Consultations',
    type: 'Consultation',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'Legislation',
    type: 'Legislation',
  },
  {
    name: 'Parliamentary record',
    type: 'ParliamentaryRecord',
  },
  {
    name: 'Committee publications',
    type: 'CommitteePublication',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'Regulations',
    type: 'Regulation',
    hidden: getAppSite() === 'global',
  },
  {
    name: 'Library material',
    type: 'CommonsLibraryArticle',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'Lobbying material',
    type: 'UserContent',
  },
  {
    name: 'X posts',
    type: 'tweet',
    hidden: import.meta.env.VITE_APP_ENABLE_TWITTER === 'false',
  },
];

const PriorityUpdatesFilters = [
  {
    name: 'Resource',
    pages: ['PriorityUpdates', 'Dashboard'],
    filterName: 'contentSource',
    options: sourceOptions.filter((item) => !item.hidden).map((item) => ({ name: item.name, filterValue: item.type })),
    prefix: 'contentSource',
    updateFilter: true,
    configHidden: ConfigData?.filters?.source?.configHidden,
    expandedByDefault: true,
    showAll: true,
  },
];

export default PriorityUpdatesFilters;
